import { render } from "./LockRecord.vue?vue&type=template&id=281215f8&scoped=true"
import script from "./LockRecord.vue?vue&type=script&lang=js"
export * from "./LockRecord.vue?vue&type=script&lang=js"

import "./LockRecord.vue?vue&type=style&index=0&id=281215f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281215f8"]])

export default __exports__